import * as React from "react";
const MenuCalendar = (props) => (
  <svg
    width={20}
    height={23}
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.25 5.25C5.84 5.25 5.5 4.91 5.5 4.5V1.5C5.5 1.09 5.84 0.75 6.25 0.75C6.66 0.75 7 1.09 7 1.5V4.5C7 4.91 6.66 5.25 6.25 5.25Z"
      fill="#4B5155"
    />
    <path
      d="M14.25 5.25C13.84 5.25 13.5 4.91 13.5 4.5V1.5C13.5 1.09 13.84 0.75 14.25 0.75C14.66 0.75 15 1.09 15 1.5V4.5C15 4.91 14.66 5.25 14.25 5.25Z"
      fill="#4B5155"
    />
    <path
      d="M18.75 9.33984H1.75C1.34 9.33984 1 8.99984 1 8.58984C1 8.17984 1.34 7.83984 1.75 7.83984H18.75C19.16 7.83984 19.5 8.17984 19.5 8.58984C19.5 8.99984 19.16 9.33984 18.75 9.33984Z"
      fill="#4B5155"
    />
    <path
      d="M14.25 22.25H6.25C2.6 22.25 0.5 20.15 0.5 16.5V8C0.5 4.35 2.6 2.25 6.25 2.25H14.25C17.9 2.25 20 4.35 20 8V16.5C20 20.15 17.9 22.25 14.25 22.25ZM6.25 3.75C3.39 3.75 2 5.14 2 8V16.5C2 19.36 3.39 20.75 6.25 20.75H14.25C17.11 20.75 18.5 19.36 18.5 16.5V8C18.5 5.14 17.11 3.75 14.25 3.75H6.25Z"
      fill="#4B5155"
    />
    <path
      d="M6.75 14C6.62 14 6.49 13.97 6.37 13.92C6.25 13.87 6.14001 13.8 6.04001 13.71C5.95001 13.61 5.87999 13.5 5.82999 13.38C5.77999 13.26 5.75 13.13 5.75 13C5.75 12.74 5.86001 12.48 6.04001 12.29C6.14001 12.2 6.25 12.13 6.37 12.08C6.55 12 6.75001 11.98 6.95001 12.02C7.01001 12.03 7.07 12.05 7.13 12.08C7.19 12.1 7.25 12.13 7.31 12.17C7.36 12.21 7.40999 12.25 7.45999 12.29C7.49999 12.34 7.54999 12.39 7.57999 12.44C7.61999 12.5 7.65001 12.56 7.67001 12.62C7.70001 12.68 7.72001 12.74 7.73001 12.8C7.74001 12.87 7.75 12.93 7.75 13C7.75 13.26 7.63999 13.52 7.45999 13.71C7.26999 13.89 7.01 14 6.75 14Z"
      fill="#4B5155"
    />
    <path
      d="M10.25 13.9999C9.99 13.9999 9.73001 13.8899 9.54001 13.7099C9.50001 13.6599 9.46001 13.6099 9.42001 13.5599C9.38001 13.4999 9.34999 13.4399 9.32999 13.3799C9.29999 13.3199 9.27999 13.2599 9.26999 13.1999C9.25999 13.1299 9.25 13.0699 9.25 12.9999C9.25 12.8699 9.27999 12.7399 9.32999 12.6199C9.37999 12.4999 9.45001 12.3899 9.54001 12.2899C9.82001 12.0099 10.27 11.9199 10.63 12.0799C10.76 12.1299 10.86 12.1999 10.96 12.2899C11.14 12.4799 11.25 12.7399 11.25 12.9999C11.25 13.0699 11.24 13.1299 11.23 13.1999C11.22 13.2599 11.2 13.3199 11.17 13.3799C11.15 13.4399 11.12 13.4999 11.08 13.5599C11.04 13.6099 11 13.6599 10.96 13.7099C10.86 13.7999 10.76 13.8699 10.63 13.9199C10.51 13.9699 10.38 13.9999 10.25 13.9999Z"
      fill="#4B5155"
    />
    <path
      d="M6.75 17.4999C6.62 17.4999 6.49 17.4699 6.37 17.4199C6.25 17.3699 6.14001 17.2999 6.04001 17.2099C5.95001 17.1099 5.87999 17.0099 5.82999 16.8799C5.77999 16.7599 5.75 16.6299 5.75 16.4999C5.75 16.2399 5.86001 15.9799 6.04001 15.7899C6.14001 15.6999 6.25 15.6299 6.37 15.5799C6.74 15.4199 7.17999 15.5099 7.45999 15.7899C7.49999 15.8399 7.54999 15.8899 7.57999 15.9399C7.61999 15.9999 7.65001 16.0599 7.67001 16.1199C7.70001 16.1799 7.72001 16.2399 7.73001 16.3099C7.74001 16.3699 7.75 16.4399 7.75 16.4999C7.75 16.7599 7.63999 17.0199 7.45999 17.2099C7.26999 17.3899 7.01 17.4999 6.75 17.4999Z"
      fill="#4B5155"
    />
  </svg>
);
export default MenuCalendar;